const th = {
  layout: {
    cos_button: {
      phone: 'โทรศัพท์',
      update_phone_number_message: 'เบอร์โทรศัพท์ได้รับการอัปเดตเรียบร้อยแล้ว!'
    },
    time: {
      days: 'วัน',
      hours: 'ชั่วโมง',
      mins: 'นาที',
      secs: 'วินาที',
      starts: 'เริ่ม',
      starts_immediately: 'เริ่มทันที'
    },
    field: {
      host: 'เจ้าภาพ'
    },
    copy: 'คัดลอก'
  },
  validations: {
    email: 'ต้องเป็นอีเมลที่ถูกต้อง',
    phone: 'ต้องเป็นเบอร์โทรศัพท์ที่ถูกต้อง',
    required_field: 'เป็นฟิลด์ที่ต้องระบุ'
  },
  mailer: {
    need_help: 'ต้องการความช่วยเหลือ?',
    stop_reminders: 'หยุดรับการแจ้งเตือน',
    cancel_registration: 'ยกเลิกการลงทะเบียน',
    report_abuse: 'รายงานการละเมิด'
  },
  datetime: {
    no_sessions: 'ไม่มีเซสชันที่ว่าง',
    empty_label: 'วันที่/เวลา'
  },
  errors: {
    verification_failed: 'การยืนยันล้มเหลว กรุณาลองใหม่อีกครั้ง',
    session_unavailable: 'ช่วงเวลาที่คุณเลือกไม่สามารถใช้งานได้อีกต่อไป กรุณาเลือกช่วงเวลาอื่น',
    challenge_email_mismatch: 'กรุณาลงทะเบียนด้วยอีเมลเดียวกับที่คุณใช้ลงทะเบียนเข้าร่วมกิจกรรม'
  }
}

export default th
